// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function withTimeout(promise: Promise<any>, ms: number, label: string): Promise<any> {
  return Promise.race([
    promise,
    new Promise((_, rej) => setTimeout(() => rej(new Error(`${label} timed out`)), ms)),
  ]);
}
